module.exports = "/packs/images/homepage/activity/football_tablet~8b41a0c6b86526ec1ddd0e7885b63a62.jpg";